import { UserViewportBoundsPart } from "../../shared/types/PromptPart";
import { AgentHelpers } from "../AgentHelpers";
import { PromptPartUtil, registerPromptPartUtil } from "./PromptPartUtil";

export const UserViewportBoundsPartUtil = registerPromptPartUtil(
  class UserViewportBoundsPartUtil extends PromptPartUtil<UserViewportBoundsPart> {
    static override type = "userViewportBounds" as const;

    override getPart(
      _request: unknown,
      helpers: AgentHelpers,
    ): UserViewportBoundsPart {
      return {
        type: "userViewportBounds",
        userBounds: helpers.roundBox(this.editor.getViewportPageBounds()),
      };
    }
  },
);
